import { z } from 'zod';

export const RegisterSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  password: z.string().min(10).max(200),
  name: z.string().trim().min(1).max(120),
});
export type RegisterInput = z.infer<typeof RegisterSchema>;

const OtpCode = z.string().trim().regex(/^\d{6}$/, 'Codice di 6 cifre');

export const LoginSchema = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  password: z.string().min(1).max(200),
  /** Codice TOTP: obbligatorio se l'utente ha attivato l'MFA (altrimenti la risposta è `mfa_required`). */
  otp: OtpCode.optional(),
});
export type LoginInput = z.infer<typeof LoginSchema>;

export const RefreshSchema = z.object({ refresh_token: z.string().min(20).max(200) });
export type RefreshInput = z.infer<typeof RefreshSchema>;

export const TokenPairSchema = z.object({
  access_token: z.string(),
  access_expires_in: z.number().int(),
  refresh_token: z.string(),
});
export type TokenPair = z.infer<typeof TokenPairSchema>;

export const MeSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  name: z.string(),
  mfa_enabled: z.boolean(),
});
export type Me = z.infer<typeof MeSchema>;

export const MfaSetupSchema = z.object({
  /** URI `otpauth://` da mostrare come QR nell'app di autenticazione. */
  otpauth_url: z.string(),
  /** Segreto in chiaro per l'inserimento manuale: mostrato una sola volta. */
  secret: z.string(),
});
export type MfaSetup = z.infer<typeof MfaSetupSchema>;

export const MfaCodeSchema = z.object({ otp: OtpCode });
export type MfaCodeInput = z.infer<typeof MfaCodeSchema>;
